module.exports = __webpack_public_path__ + "img/50.985eecb8.png";